export const loadingConstants = {
  SHOW_LOADING: 'SHOW_LOADING'
}
